import React from 'react';

import { Loader, } from 'rsuite';
import { Table, } from 'react-bootstrap';
import { Paper, Grid, Container,  } from '@material-ui/core';

import CorpoMon from '../../components/Mon/indexMain';

import '../Main/Main.css';


function ServerMonitoringTable({ loading, data, }) {
  return (
    <Grid
      item
      xs={12}
    >
      <Container
        component={Paper}
        elevation={2}
        maxWidth="xl"
      >
        <br />

        <Table responsive hover>
          <thead>
            <tr>
              <th className="TableNames">Empresa</th>
              <th className="TableNames">Servidor</th>
              <th className="TableNames">Squid</th>
              <th className="TableNames">Firewall</th>
              <th className="TableNames">Samba</th>
              <th className="TableNames">HTTP</th>
              <th className="TableNames">VPN</th>
              <th className="TableNames">Máquina</th>
              <th className="TableNames">Rede</th>
              <th className="TableNames">DHCP</th>
              <th className="TableNames">DNS</th>
              <th className="TableNames">MYSQL</th>
              <th className="TableNames">Backup</th>
              <th className="TableNames">Disco</th>
              <th className="TableNames">Memória</th>
              <th className="TableNames">BKP</th>
              <th className="TableNames">LAST UPDATE</th>
            </tr>
          </thead>

          {
            loading ?
            <Loader content="loading" /> :
            data
              .sort((a, b) => a.fantasia.localeCompare(b.fantasia))
              .map((body) => {
                return (
                  <CorpoMon
                    key={body.cod_servidor}
                    data={body}
                  />
                );
              })
          }
          <br />
        </Table>
      </Container>
    </Grid>
  );
}

export default ServerMonitoringTable;
